import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import {useSetting} from "../SettingsContext";

const Footer = () => {
	const setting = useSetting();
    const style = {
        position: 'absolute',
        left: '-5000px'
      };
	const [faqs, setFaqs] = useState([]);
	useEffect(() => {
		const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
		const Url = process.env.REACT_APP_API_FAQS;
		axios.get(`${apiBaseUrl}${Url}`)
			.then(response => setFaqs(response.data))
			.catch(error => console.error("Error fetching API", error));
	}, []);

	return (
    <footer className="footer-area section-gap">
		<div className="container">
			<div className="row">
				<div className="col-xl-3 col-sm-6 col-12 mb-xl-0 single-footer-widget text-center text-lg-right footer-social">
					<div id="logo">
						<Link className="nav-link" to="/" >
							<img style={{width:'250px'}} src="eliteriyadhhotel-removebg-preview.png" alt="" title=""/>
						</Link>
					</div>
					<div className="footer-bottom row align-items-center text-center text-lg-left">
						<div className="col-lg-12 col-md-12 footer-social">
							<a target="_blank" href={setting?.facebook}><i className="fab fa-facebook-f"></i></a>
							<a target="_blank" href={setting?.linkedin}><i className="fab fa-linkedin-in"></i></a>
							<a target="_blank" href={setting?.twitter}><i className="fab fa-twitter"></i></a>
							<a target="_blank" href={setting?.google_plus}><i className="fab fa-google-plus-g"></i></a>
							<a target="_blank" rel="noopener noreferrer" href={setting?.youtube}><i className="fab fa-youtube"></i></a>
						</div>
					</div>
				</div>
				<div className="col-xl-2 col-sm-6 col-6 mb-xl-0 single-footer-widget">
					<h4>Quick Links</h4>
					<ul>
						<li className="nav-item active">
							<Link className="nav-link" to="/" >Home</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/room" >Rooms</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/restaurant" >Restaurants</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/super-shop" >Shop</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/faq" >Faq's</Link>
						</li>
						<li className="nav-item submenu dropdown">
							<Link className="nav-link" to="/blog" >Blog</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/about" >About</Link>
						</li>
						<li className="nav-item">
							<Link className="nav-link" to="/contact" >Contact</Link>
						</li>
					</ul>
				</div>
				<div className="col-xl-3 col-sm-6 col-6 mb-xl-0 single-footer-widget">
					<h4 className="text-center">FAQ'S</h4>
					<ul>
						{faqs.map((faq,index) => {
							return (
								<li key={index}>
									<Link className="nav-link" to="/faq" >{faq.qn}</Link>
								</li>
							)
						})}
					</ul>
				</div>
				<div className="col-xl-4 col-md-8 col-12 mb-xl-0 single-footer-widget">
					<h4>Newsletter</h4>
					<p>You can trust us. we only send promo offers,</p>
					<div className="form-wrap" id="mc_embed_signup">
						<form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&amp;id=92a4423d01"
						 method="get" className="form-inline">
							<input className="form-control" name="EMAIL" placeholder="Your Email Address" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your Email Address'"
							 required="" type="email" />
							<button className="click-btn btn btn-default text-uppercase">subscribe</button>
							<div style={style}>
								<input name="b_36c4fd991d266f23781ded980_aefe40901a" tabindex="-1" value="" type="text" />
							</div>

							<div className="info"></div>
						</form>
					</div>
				</div>
			</div>
			<div className="footer-bottom row align-items-center text-center text-lg-left">
				<p className="footer-text m-0">
					Copyright &copy;
					<script>document.write(new Date().getFullYear());</script>
					All rights reserved by Elite Riyadh Company
				</p>
			</div>
		</div>
	</footer>
  );
};

export default Footer;